import { Record as record } from 'immutable';
import { BulletinSeverity } from '../constants/AppConstants';

const defaults = {
    id: null,
    category: null,
    severity: null,
    title: null,
    description: null,
    url: null
};

class Bulletin extends record(defaults) {
    static fromJSON (json = {}) {
        return new Bulletin(json);
    }

    isP1 () {
        return this.severity === BulletinSeverity.P1;
    }
}

export default Bulletin;



// WEBPACK FOOTER //
// ./src/records/Bulletin.js